'use client'

import Script from 'next/script'

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || 'GTM-PCGN7DSK'

/**
 * Google Tag Manager — charge GTM qui gère ensuite GA4, Google Ads,
 * remarketing et toutes les balises de conversion.
 *
 * Le Consent Mode v2 reste géré par CookieConsent.tsx via dataLayer.
 * GA4 doit être configuré comme balise DANS GTM (pas en direct).
 *
 * Pour changer le conteneur : set NEXT_PUBLIC_GTM_ID in .env
 */
export default function GoogleAnalytics() {
  if (!GTM_ID) return null

  return (
    <Script id="google-tag-manager" strategy="lazyOnload">
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `}
    </Script>
  )
}
